import { ENV } from '@/constants';
import { formatConverterSchemaItemList } from '../formatConverterSchema';

export const schemaObject_ImageConverter = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai/image-converter',
			name: 'Image Converter — Convert Photos Online. Transform Pictures Instantly to Popular Formats | Lift',
			description:
				'Convert images between formats effortlessly with Lift photo converter. No watermark. Upload photo, choose your output format, and download in seconds. Try now!',
			image: 'https://liftapp.ai/seo-image.webp',
			mainEntity: [
				{ '@id': 'https://liftapp.ai/image-converter#product' },
				{ '@id': 'https://liftapp.ai/image-converter#howto' },
				{ '@id': 'https://liftapp.ai/image-converter#benefits' },
				{ '@id': 'https://liftapp.ai/image-converter#faq' },
				{ '@id': 'https://liftapp.ai/image-converter#why-lift' },
				{ '@id': 'https://liftapp.ai/image-converter#format-converter' },
				{ '@id': 'https://liftapp.ai/image-converter#all-in-one' },
			],
		},
		// product
		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai/image-converter#product',
			name: 'Image Format Converter Online',
			description:
				"Convert images between popular format with ease. Transform your photos seamlessly while maintaining quality. Try Lift's image converter now!",
			url: 'https://liftapp.ai/image-converter',
			fileFormat: [
				'image/jpeg',
				'image/png',
				'image/webp',
				'image/heic',
				'image/tiff',
				'image/bmp',
			],
			memoryRequirements: 'Max file size: 20MB',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},
		// howto
		{
			'@type': 'HowTo',
			'@id': 'https://liftapp.ai/image-converter#howto',
			name: 'How it works',
			step: [
				{
					'@type': 'HowToStep',
					position: 1,
					name: 'Upload Your Image',
					text: 'Drag and drop an image from your device.',
				},
				{
					'@type': 'HowToStep',
					position: 2,
					name: 'Choose an Output Format',
					text: "Select your desired output format — we'll handle the conversion automatically.",
				},
				{
					'@type': 'HowToStep',
					position: 3,
					name: 'Download Your File',
					text: 'Get your converted image in seconds. Download a high-quality file ready to use anywhere.',
				},
			],
		},
		// benefits
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-converter#benefits',
			name: 'Who can benefit from Image Converter?',
			description:
				'Lift Image Converter helps anyone convert pictures between formats while preserving quality. No quality loss, wide format support, simple 3-step process.',
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'No Quality Loss — Our online photo converter preserves your image quality.',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Wide Format Support — Convert between JPEG, JPG, PNG, BMP, TIFF, WEBP, and HEIC.',
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Simple 3-Step Process — Upload, convert, and download in seconds.',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'All-in-One Tool — Edit images, compress files, and optimize photos in one place.',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Cross-Platform Access — Use on iOS, Android, or Web anywhere, anytime.',
				},
			],
			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/benefits.d4ac6242.webp',
				name: 'Image to image converter tool',
				description: 'Image format converter — Lift',
			},
		},
		// faq
		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai/image-converter#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'How does Lift image converter work?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Lift's online image converter uses advanced algorithms to transform your pictures seamlessly between formats. Simply upload your file, select your desired output format (JPEG/JPG, PNG, BMP, TIFF, WEBP, or HEIC), and our tool automatically processes it while preserving quality. Download your converted photo in seconds — no technical skills required.",
					},
				},
				{
					'@type': 'Question',
					name: 'Will the image lose quality after conversion?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "No. Lift's photo converter is designed to maintain maximum image quality during the conversion process. We use optimized compression techniques to ensure your files remain clear and sharp, without compromising visual fidelity or color accuracy.",
					},
				},
				{
					'@type': 'Question',
					name: 'What image formats does Lift support?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift supports conversion between all major image file formats including JPEG/JPG, PNG, BMP, TIFF, WEBP, and HEIC. You can convert from any supported format to any other, giving you complete flexibility for your picture file conversion needs.',
					},
				},
				{
					'@type': 'Question',
					name: 'Is it safe to convert files with Lift?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: "Absolutely. Lift prioritizes your privacy and security. All image file conversions are processed securely, and we don't store or share your photos. Your converted pictures are available only to you.",
					},
				},
			],
		},
		// why-lift
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-converter#why-lift',
			name: "Why Lift's Image Converter stands out",
			description:
				"Discover the advantages of Lift's image format converter: no quality loss, wide format support, simple 3-step process, all-in-one tool, and cross-platform access.",
			itemListOrder: 'Unordered',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'No Quality Loss',
					description:
						'Our online photo converter preserves your image quality. Convert files without compromising resolution, clarity, or color accuracy.',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Wide Format Support',
					description:
						"Convert image files between JPEG, JPG, PNG, BMP, TIFF, WEBP, and HEIC. Lift's picture converter handles all major formats for complete flexibility.",
				},
				{
					'@type': 'ListItem',
					position: 3,
					name: 'Simple 3-Step Process',
					description:
						'Upload, convert, and download. Our image to image converter is designed for ease — transform pictures in seconds with zero learning curve.',
				},
				{
					'@type': 'ListItem',
					position: 4,
					name: 'All-in-One Tool',
					description:
						'Beyond format conversion, Lift lets you edit images, compress files, and optimize photos all in one place. Complete picture file converter solution.',
				},
				{
					'@type': 'ListItem',
					position: 5,
					name: 'Cross-Platform Access',
					description:
						'Use our online image converter on iOS, Android, or Web. Convert photo files anywhere, anytime with seamless cloud-based processing.',
				},
			],

			image: {
				'@type': 'ImageObject',
				contentUrl:
					'https://liftapp.ai/_next/static/media/whyLift.b11abf6c.webp',
				name: 'How to convert image format online',
				description: 'How to convert image format online — Lift.',
			},
		},
		// format-converter
		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai/image-converter#format-converter',
			name: 'Popular Image Conversion Formats',
			description:
				'Popular image format conversion tools — WEBP, HEIC, PNG, JPEG, JPG, TIFF, BMP. Convert between formats instantly with Lift.',
			itemListOrder: 'Unordered',
			...formatConverterSchemaItemList,
		},
		// all-in-one
		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai/image-converter#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
				{
					'@type': 'ListItem',
					position: 2,
					name: 'Image Converter',
					item: 'https://liftapp.ai/image-converter',
				},
			],
		},
	],
};
